import "./HomeAdditions.module.css";
import Header from "@/reusable_sections/Header";
import Intro from "./sections/Intro";
import Additions from "./sections/Additions";
import AdditionCta from "./sections/AdditionCta";
import Basement from "./sections/Basement";
import OutdoorLiving from "./sections/OutdoorLiving";
import Gallery from "./sections/Gallery";
import Questions from "./sections/Questions";
import CallAction from "./sections/CallAction";
import EstimateRequestForm from "./sections/EstimateRequestForm";
import Footer from "@/reusable_sections/Footer";
export default function HomeAdditionsPage() {
  return <div>
      <Header />
      <Intro />
      <Additions />
      <AdditionCta />
      <Basement />
      <OutdoorLiving />
      <Gallery />
      <Questions />
      <EstimateRequestForm />
      <CallAction />
      <Footer />
    </div>;
}